module.exports = __webpack_public_path__ + "img/video-bg.513597fc.jpg";